var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"alerts-container"},_vm._l((_vm.alerts),function(alert){return _c('Alert',_vm._b({key:alert.id,attrs:{"auto-open":""}},'Alert',alert,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }